import { RunDetailPage as RunDetailFeature } from '@/features/calibration-runs/components/detail/run-detail-page';
import { runDetailRoute } from '../routes';

export function RunDetailPage() {
  const { runId } = runDetailRoute.useParams();
  return <RunDetailFeature runId={runId} />;
}
